var _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1773,
    height: 476,
    viewBox: "0 0 1773 476",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1067 540V359H976V449H796V540H1067Z",
    fill: "#E048BC",
    fillOpacity: 0.24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1_9)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 359,
    width: 181,
    height: 181,
    fill: "url(#paint0_linear_1_9)",
    fillOpacity: 0.48
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1427 0H1246V90H1336V180H1517V89H1427V0Z",
    fill: "url(#paint1_linear_1_9)",
    fillOpacity: 0.32
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_9",
    x: 540,
    y: 103,
    width: 783,
    height: 693,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 128,
    result: "effect1_foregroundBlur_1_9"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1_9",
    x: 0,
    y: 103,
    width: 693,
    height: 693,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 128,
    result: "effect1_foregroundBlur_1_9"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1_9",
    x: 990,
    y: -256,
    width: 783,
    height: 692,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 128,
    result: "effect1_foregroundBlur_1_9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_9",
    x1: 437,
    y1: 449,
    x2: 256,
    y2: 449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80F0FF",
    stopOpacity: 0.48
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_9",
    x1: 1246,
    y1: 90,
    x2: 1517,
    y2: 90,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6648E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6648E0",
    stopOpacity: 0.48
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundColor);
export default __webpack_public_path__ + "static/media/background-color.fede501e62e679435ff68a671dd82236.svg";
export { ForwardRef as ReactComponent };